import { render } from "./OrderPlacedModal.vue?vue&type=template&id=409f2e8c"
import script from "./OrderPlacedModal.vue?vue&type=script&lang=js"
export * from "./OrderPlacedModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__